

export class Serie {
    id: number;
    name: string;
    inventoryAccess: boolean;
    description: string;
    department: Departamento;
    serieGroups?: GrupoSerie[];
    inventoryLevelId: number;

    constructor() { }

    static toModel(json: string): Serie {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }

        const toReturn = new Serie();
        toReturn.id = data.Id;

        toReturn.name = data.NOMBRE;
        toReturn.inventoryAccess = data.ACCESO_INVENTARIO;
        toReturn.description = data.DESCRIPCION;
        toReturn.department = Departamento.toModel(JSON.stringify(data.Departamento));

        toReturn.serieGroups = data.GrupoSerie.map(grupoSerie => GrupoSerie.toModel(JSON.stringify(grupoSerie)));
        toReturn.inventoryLevelId = data.ID_NIVEL_INVENTARIO;

        return toReturn;
    }

}

export class Departamento {
    id: number;
    name: string;
    description: string;
    clienteId: number;

    constructor() { }

    static toModel(json: string): Departamento {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }

        const toReturn = new Departamento();

        toReturn.id = data.Id;
        toReturn.name = data.NOMBRE;
        toReturn.description = data.DESCRIPCION;
        toReturn.clienteId = data.ID_CLIENTE;

        return toReturn;
     }
}

export class GrupoSerie {
    id: number;
    groupId: number;
    serieId: number;

    constructor() { }

    static toModel(json: string): GrupoSerie {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }

        const toReturn = new GrupoSerie();

        toReturn.id = data.Id;
        toReturn.groupId = data.ID_GRUPO;
        toReturn.serieId = data.ID_SERIE;

        return toReturn;
    }
}

